import React, { useState, useEffect } from 'react'
import ProgressBar from '../ProgressBar/index'
import GameCard from '../GameCard/index'
import './styles.scss'
import { formatPoints } from '../../Helpers/Utils'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import importer from '@takedapdt/biolife-core/src/importer'
const LoaderBar = importer('Components/Loaders/LoaderBar')
import WhatToExpectFlow from '../LoyaltyGameWhatToExpectModal'
const loyaltyActions = importer('Stores/Loyalty/Actions')
const { gameStepStatus } = importer('Constant/Utils', null)
const Config = importer('Config')
const GameCompleteModal = importer('Components/QuestCompleteComponent/GameCompleteModal')
const GameStepComplete = importer('Components/GameStepComplete')
import { useTranslation } from 'react-i18next'
import TextCTAModal from '../Modal/TextCTAModal'
import { ReactComponent as InfoIcon } from '../../../assets/media/icons/information-icon.svg'
const Modal = importer('Components/Modal')
const WhatToExpectFlowModal = importer('Components/LoyaltyGameWhatToExpectModal/Modal')

const GameDashboard = ({
  donor,
  getLoyaltyGameData,
  loyaltyGameDataSuccess,
  getLoyaltyGameDataLoading,
  handleLoyaltyEnrolmentButtonClick,
  openStepCompleteModal,
  updateLoyaltyGameDataSuccess,
  updateLoyaltyGameData
}) => {
  const { t, i18n } = useTranslation('LoyaltyGame')
  const navigate = useNavigate()
  const [gameData, setGameData] = useState([])
  const [progressData, setProgressData] = useState(0)
  const [showTermsConditionPopup, setShowTermsConditionPopup] = useState(false)
  const [showStepCompleteModal, setshowStepCompleteModal] = useState(false)
  const [selectedActionKey, setSelectedActionKey] = useState(null)
  const [isOpenWhatToExpectFlowModal, setIsOpenWhatToExpectFlowModalModal] = useState(false)

  useEffect(() => {
    if (loyaltyGameDataSuccess) {
      // To sort the completed steps to the end of array
      let getGameData = { ...loyaltyGameDataSuccess }
      const sortedData = getGameData?.stepsData.sort((a, b) => {
        if (a.completed && !b.completed) return 1
        if (!a.completed && b.completed) return -1
        return a.stepNumber - b.stepNumber
      })
      getGameData.stepsData = sortedData
      setGameData(getGameData)
    }
  }, [loyaltyGameDataSuccess])

  useEffect(() => {
    if (openStepCompleteModal) {
      handleStepCompleteModalOpen()
    }
  }, [openStepCompleteModal])

  useEffect(() => {
    // To calculate the progress bar value
    if (gameData?.stepsData?.length) {
      // Multiplying it by 20 to get the percentage value for progressing
      let progressValue = gameData?.stepsData?.filter((step) => step?.completed)?.length * 20
      setProgressData(progressValue)
    }
  }, [gameData])

  const closeWhatToExpectModal = (isLastCarousalScreen) => {
    if (
      isLastCarousalScreen == 3 &&
      loyaltyGameDataSuccess &&
      !loyaltyGameDataSuccess?.stepsMetadata?.[gameStepStatus.WHAT_TO_EXPECT]?.completed
    ) {
      updateLoyaltyGameData(donor?.sfid, {
        actionKey: gameStepStatus.WHAT_TO_EXPECT,
        action: true
      })
    } else {
      setIsOpenWhatToExpectFlowModalModal(false)
    }
  }

  useEffect(() => {
    if (updateLoyaltyGameDataSuccess && selectedActionKey) {
      if (
        updateLoyaltyGameDataSuccess?.stepCompleted == gameStepStatus.WHY_DONATE &&
        selectedActionKey == gameStepStatus.WHY_DONATE &&
        !loyaltyGameDataSuccess?.stepsMetadata?.[gameStepStatus.WHY_DONATE]?.completed
      ) {
        handleStepCompleteModalOpen()
        openWhyDonateRoute()
      }
      if (
        updateLoyaltyGameDataSuccess?.stepCompleted == gameStepStatus.WHAT_TO_EXPECT &&
        selectedActionKey == gameStepStatus.WHAT_TO_EXPECT &&
        !loyaltyGameDataSuccess?.stepsMetadata?.[gameStepStatus.WHAT_TO_EXPECT]?.completed
      ) {
        setIsOpenWhatToExpectFlowModalModal(false)
        handleStepCompleteModalOpen()
      }
    }
  }, [updateLoyaltyGameDataSuccess, selectedActionKey])

  const handleCardClick = ({ completed, actionKey, points }) => {
    if (actionKey == gameStepStatus.LOYALTY_ENROLLMENT && completed) return
    else {
      setSelectedActionKey(actionKey)
      switch (actionKey) {
        case gameStepStatus.LOYALTY_ENROLLMENT:
          handleLoyaltyEnrolmentButtonClick()
          break
        case gameStepStatus.SCHEDULE_APPOINTMENT:
          navigate('/appointment-scheduling')
          break
        case gameStepStatus.WHY_DONATE:
          handleClickOnWhyDonate()
          break
        case gameStepStatus.WHAT_TO_EXPECT:
          setIsOpenWhatToExpectFlowModalModal(true)
          break
        case gameStepStatus.FINAL_DONATION:
          break
      }
    }
  }

  const handleClickOnWhyDonate = () => {
    openWhyDonateRoute()
    if (loyaltyGameDataSuccess && !loyaltyGameDataSuccess?.stepsMetadata?.[gameStepStatus.WHY_DONATE]?.completed) {
      updateLoyaltyGameData(donor?.sfid, {
        actionKey: gameStepStatus.WHY_DONATE,
        action: true
      })
    }
  }

  const openWhyDonateRoute = () => {
    const link = `${Config.WEB_APP_URL}/why-donate/patient-stories-testimonials?lng=${i18n.language}`
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  const handleStepCompleteModalOpen = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    setshowStepCompleteModal(true)
  }

  return (
    <>
      {getLoyaltyGameDataLoading ? (
        <div className='game-dashboard-container loaderContainer'>
          <LoaderBar />
        </div>
      ) : loyaltyGameDataSuccess ? (
        <>
          <div className='game-dashboard-container'>
            <div className='main-container'>
              <div className='game-container'>
                <div className='game-progress-container'>
                  <div className='game-donation-title'>{i18n.language === 'es-MX' ? gameData?.gameTitleSpanish : gameData?.gameTitle}</div>
                  <div className='game-donation-content'>
                    {t('completeMissionsToInlock').replace('(totalPoints)', formatPoints(loyaltyGameDataSuccess?.totalGamePoints))}
                    <span className='game-donation-first-text'>{t('firstDonation')}</span>
                  </div>
                  <ProgressBar
                    value={progressData}
                    totalPoints={formatPoints(gameData?.totalGamePoints)}
                    totalSteps={gameData?.stepsData}
                  />
                  <div className='game-terms-condition-container' onClick={() => setShowTermsConditionPopup(true)}>
                    <InfoIcon />
                    <span className='game-terms-condition'>{t('termsAndConditions')}</span>
                  </div>
                </div>
                <div className='game-card-block'>
                  {gameData?.stepsData?.map((step, index) => (
                    <div key={step.sfid} onClick={() => handleCardClick(step)}>
                      <GameCard
                        key={step.sfid}
                        title={i18n.language === 'es-MX' ? step?.titleSpanish : step?.title}
                        completed={step?.completed}
                        finalStep={step?.actionKey == gameStepStatus.FINAL_DONATION}
                        totalPoints={formatPoints(gameData?.totalGamePoints)}
                        actionType={step?.actionKey}
                      />
                    </div>
                  ))}
                </div>
                <div className='game-terms-condition-container-mobile' onClick={() => setShowTermsConditionPopup(true)}>
                  <InfoIcon />
                  <span className='game-terms-condition'>{t('termsAndConditions')}</span>
                </div>
                <Modal
                  maxWidth={836}
                  maxWidthMobile={342}
                  maxHeightMobile={538}
                  isOpen={showTermsConditionPopup}
                  onClose={() => setShowTermsConditionPopup(false)}
                >
                  <TextCTAModal
                    modalContent={{
                      field_component_title: { processed: `<h2><strong>${t('termsAndConditions')}<strong></h2>` },
                      field_title_color: 'orange',
                      field_component_desc: {
                        processed: i18n.language === 'en-US' ? loyaltyGameDataSuccess?.gameTnC : loyaltyGameDataSuccess?.gameTnCSpanish
                      }
                    }}
                  />
                </Modal>
              </div>
            </div>
          </div>
          <div className='bottomPadding'></div>
        </>
      ) : null}
      <GameCompleteModal
        maxWidth={836}
        maxHeight={712}
        maxHeightMobile={693}
        maxWidthMobile={374}
        isOpen={showStepCompleteModal}
        onClose={() => {
          setSelectedActionKey(null)
          setshowStepCompleteModal(false)
        }}
      >
        <GameStepComplete
          onClose={() => {
            setSelectedActionKey(null)
            setshowStepCompleteModal(false)
            setIsOpenWhatToExpectFlowModalModal(false)
          }}
          points={
            loyaltyGameDataSuccess?.stepsMetadata?.[selectedActionKey]?.points ||
            loyaltyGameDataSuccess?.stepsMetadata?.[gameStepStatus.LOYALTY_ENROLLMENT]?.points
          }
        />
      </GameCompleteModal>
      <GameCompleteModal
        maxWidth={836}
        maxHeight={712}
        maxHeightMobile={795}
        maxWidthMobile={374}
        isOpen={isOpenWhatToExpectFlowModal}
        onClose={() => {
          setSelectedActionKey(null)
          setshowStepCompleteModal(false)
        }}
        hideCloseIcon={true}
      >
        <WhatToExpectFlow onClose={(val) => closeWhatToExpectModal(val)} />
      </GameCompleteModal>
    </>
  )
}

const mapStateToProps = (state) => ({
  donor: state.donors.donors?.data,
  loyaltyGameDataSuccess: state.loyalty?.getLoyaltyGameDataSuccess,
  getLoyaltyGameDataLoading: state.loyalty?.getLoyaltyGameDataLoading,
  updateLoyaltyGameDataSuccess: state.loyalty?.updateLoyaltyGameDataSuccess
})

const mapDispatchToProps = (dispatch) => ({
  getLoyaltyGameData: (donorSfid) => dispatch(loyaltyActions.getLoyaltyGameData(donorSfid)),
  updateLoyaltyGameData: (donorSfid, data) => dispatch(loyaltyActions.updateLoyaltyGameData(donorSfid, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(GameDashboard)
